import initialState from './initialState'
import {
  FETCH_FOLDERS,
  FINISH_FETCH_FOLDERS,
  BEGIN_FETCH_FOLDERS,
  BEGIN_FETCH_USER_ALL_WATCHED_VIDEOS,
  FETCH_USER_ALL_WATCHED_VIDEOS,
  FINISH_USER_ALL_WATCHED_VIDEOS,
  BEGIN_FETCH_USER_FOLDER_WATCHED_VIDEOS,
  FETCH_USER_FOLDER_WATCHED_VIDEOS,
  FINISH_USER_FOLDER_WATCHED_VIDEOS,
  ADD_UNLOCKED_MIAZGA_ID,
} from '../actions/actionTypes'
import moment from 'moment'

export default function folderStuff(state = initialState.folders, action) {
  let newState
  switch (action.type) {
    case BEGIN_FETCH_FOLDERS:
      return { ...state, isLoading: true }
    case FETCH_FOLDERS:
      newState = action.folders

      return { ...state, folders: action.folders }
    case FINISH_FETCH_FOLDERS:
      return { ...state, isLoading: false }

    case BEGIN_FETCH_USER_ALL_WATCHED_VIDEOS:
      return { ...state, isLoading: true }
    case FETCH_USER_ALL_WATCHED_VIDEOS:
      return {
        ...state,
        userAllWatchedVideos: [
          ...action.videos.map((video) =>
            video.watched_datetime != null
              ? {
                  ...video,
                  watched_datetime: moment(video.watched_datetime)
                    .local()
                    .format(),
                }
              : video
          ),
        ],
      }
    case FINISH_USER_ALL_WATCHED_VIDEOS:
      return { ...state, isLoading: false }

    case BEGIN_FETCH_USER_FOLDER_WATCHED_VIDEOS:
      return { ...state, isLoading: true }
    case FETCH_USER_FOLDER_WATCHED_VIDEOS:
      return {
        ...state,
        userFolderWatchedVideos: [
          ...action.videos.map((video) =>
            video.watched_datetime != null
              ? {
                  ...video,
                  watched_datetime: moment(video.watched_datetime)
                    .local()
                    .format(),
                }
              : video
          ),
        ],
      }
    case FINISH_USER_FOLDER_WATCHED_VIDEOS:
      return { ...state, isLoading: false }

    case ADD_UNLOCKED_MIAZGA_ID:
      return { ...state, userUnlockedMiazgas: action.userUnlockedMiazgas }

    default:
      return state
  }
}
